import React, { useState } from 'react';

const MobileBottomNav = ({
  currentView,
  setCurrentView,
  user,
  openTicketsCount = 0,
  unreadMessagesCount = 0,
}) => {
  const [showMoreDrawer, setShowMoreDrawer] = useState(false);

  const handleSelectView = (view) => {
    setCurrentView(view);
    setShowMoreDrawer(false);
  };

  // Primary 4 tabs + More
  const primaryTabs = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      id: 'tickets',
      label: 'Tickets',
      badge: openTicketsCount > 0 ? openTicketsCount : null,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
        </svg>
      ),
    },
    {
      id: 'chat',
      label: 'Chat',
      badge: unreadMessagesCount > 0 ? unreadMessagesCount : null,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
    },
    {
      id: 'assets',
      label: 'Assets',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
    },
  ];

  // Grouped Navigation in More Bottom Sheet with sleek SVG icons
  const workspaceItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      desc: 'Analytics & Metrics',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
        </div>
      ),
    },
    {
      id: 'tickets',
      label: 'Tickets',
      desc: 'Active Support Queue',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-amber-50 text-amber-600 border border-amber-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'closed-tickets',
      label: 'Closed Tickets',
      desc: 'Resolution Archive',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'solutions',
      label: 'Solutions Hub',
      desc: 'Knowledge Base & FAQ',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-yellow-50 text-yellow-600 border border-yellow-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'assets',
      label: 'Hardware Assets',
      desc: 'Equipment Fleet',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-purple-50 text-purple-600 border border-purple-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'chat',
      label: 'Team Chat',
      desc: 'Direct & Team Messages',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-indigo-50 text-indigo-600 border border-indigo-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'teams',
      label: 'Teams',
      desc: 'Workspace Groups',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-teal-50 text-teal-600 border border-teal-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
      ),
    },
  ];

  const intelligenceItems = [
    {
      id: 'analytics',
      label: 'Analytics',
      desc: 'Metrics & SLA Health',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-rose-50 text-rose-600 border border-rose-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'reports',
      label: 'Executive Reports',
      desc: 'SLA & Performance PDF',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-purple-50 text-purple-600 border border-purple-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      ),
    },
    {
      id: 'infrastructure',
      label: 'IT Infrastructure',
      desc: 'Fleet Health & Downtimes',
      icon: (
        <div className="w-7 h-7 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
      ),
    },
  ];

  const adminItems = [
    ...(user?.role === 'admin' || user?.role === 'superadmin' ? [
      {
        id: 'users',
        label: 'User Management',
        desc: 'Access & 2FA Controls',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-cyan-50 text-cyan-600 border border-cyan-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </div>
        ),
      },
      {
        id: 'manage-groups',
        label: 'Manage Groups',
        desc: 'Group Assignment',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-amber-50 text-amber-600 border border-amber-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
        ),
      },
      ...((user?.role === 'superadmin' || user?.webhook_enabled === true || (Array.isArray(user?.plan_features) && user.plan_features.some(f => /webhook/i.test(f)))) ? [
        {
          id: 'webhooks',
          label: 'Webhook Integrations',
          desc: 'Custom Pricing & APIs',
          icon: (
            <div className="w-7 h-7 rounded-xl bg-yellow-50 text-yellow-600 border border-yellow-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
          ),
        }
      ] : []),
      ...(user?.role === 'admin' ? [
        {
          id: 'subscription',
          label: 'Billing & Plan',
          desc: 'Cashfree & Quotas',
          icon: (
            <div className="w-7 h-7 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
            </div>
          ),
        }
      ] : []),
    ] : []),
    ...(user?.role === 'superadmin' ? [
      {
        id: 'clients',
        label: 'Clients Directory',
        desc: 'Tenants & Quotas',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
        ),
      },
      {
        id: 'subscription-plans',
        label: 'Plans & Packages',
        desc: 'Tiers & Pricing',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        ),
      },
      {
        id: 'superadmin-security',
        label: 'Security & Governance',
        desc: 'Threats & Impersonate',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-red-50 text-red-600 border border-red-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
        ),
      },
      {
        id: 'superadmin-settings',
        label: 'Platform Settings',
        desc: 'System Secrets & TOTP',
        icon: (
          <div className="w-7 h-7 rounded-xl bg-slate-100 text-slate-700 border border-slate-200 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        ),
      },
    ] : []),
  ];

  const isPrimaryActive = primaryTabs.some((tab) => tab.id === currentView);

  return (
    <>
      {/* 1. Android Material 3 Fixed Bottom Navigation Bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-lg border-t border-slate-200/90 shadow-2xl px-2 py-1 flex items-center justify-around select-none">
        {primaryTabs.map((tab) => {
          const isActive = currentView === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => handleSelectView(tab.id)}
              className="flex-1 flex flex-col items-center justify-center py-1 relative group active:scale-95 transition-transform"
            >
              {/* Active Pill Accent */}
              <div
                className={`px-4 py-1 rounded-full transition-all duration-200 relative flex items-center justify-center ${
                  isActive
                    ? 'bg-gradient-to-r from-emerald-500/15 via-emerald-500/20 to-teal-500/15 text-emerald-700'
                    : 'text-slate-500 hover:text-slate-800'
                }`}
              >
                {tab.icon}
                {tab.badge && (
                  <span className="absolute -top-1 -right-1 bg-emerald-600 text-white text-[9px] font-black px-1.5 py-0.2 rounded-full ring-2 ring-white shadow-2xs">
                    {tab.badge}
                  </span>
                )}
              </div>
              <span
                className={`text-[10px] tracking-tight mt-0.5 transition-colors font-bold ${
                  isActive ? 'text-emerald-700' : 'text-slate-500'
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}

        {/* More Tab */}
        <button
          onClick={() => setShowMoreDrawer(true)}
          className="flex-1 flex flex-col items-center justify-center py-1 relative group active:scale-95 transition-transform"
        >
          <div
            className={`px-4 py-1 rounded-full transition-all duration-200 relative flex items-center justify-center ${
              !isPrimaryActive || showMoreDrawer
                ? 'bg-gradient-to-r from-emerald-500/15 via-emerald-500/20 to-teal-500/15 text-emerald-700'
                : 'text-slate-500 hover:text-slate-800'
            }`}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </div>
          <span
            className={`text-[10px] tracking-tight mt-0.5 transition-colors font-bold ${
              !isPrimaryActive || showMoreDrawer ? 'text-emerald-700' : 'text-slate-500'
            }`}
          >
            Menu
          </span>
        </button>
      </nav>

      {/* 2. Slide-up Android Bottom Sheet Drawer */}
      {showMoreDrawer && (
        <div className="fixed inset-0 z-50 md:hidden flex flex-col justify-end animate-fadeIn">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs transition-opacity"
            onClick={() => setShowMoreDrawer(false)}
          />

          {/* Sheet Container */}
          <div className="relative bg-white rounded-t-3xl border-t border-slate-200 shadow-2xl max-h-[85vh] overflow-y-auto z-10 animate-slideUp">
            {/* Top Drag Handle */}
            <div className="sticky top-0 bg-white pt-3 pb-2 flex justify-center z-10 border-b border-slate-100/60">
              <div className="w-12 h-1.5 bg-slate-300 rounded-full" />
            </div>

            {/* Header */}
            <div className="px-5 py-3 flex items-center justify-between border-b border-slate-100">
              <div className="flex items-center gap-3">
                <img
                  src="/nd.png"
                  alt="NEXDESK"
                  className="w-9 h-9 rounded-xl object-contain bg-slate-50 border border-slate-100 p-0.5 shadow-2xs"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/icon-192x192.png';
                  }}
                />
                <div>
                  <h3 className="font-extrabold text-slate-900 text-sm tracking-tight leading-none">
                    NEXDESK WORKSPACE
                  </h3>
                  <p className="text-[11px] font-bold text-slate-400 mt-1 leading-none">
                    {user?.role?.toUpperCase() || 'USER'} • All Modules
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowMoreDrawer(false)}
                className="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 flex items-center justify-center font-bold text-xs transition-colors"
              >
                ✕
              </button>
            </div>

            {/* Grouped Modules */}
            <div className="p-4 space-y-4 text-xs">
              {/* Workspace */}
              <div>
                <div className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2 px-1">
                  Workspace
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {workspaceItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => handleSelectView(item.id)}
                      className={`p-2.5 rounded-2xl border text-left flex items-start gap-2.5 transition-all ${
                        currentView === item.id
                          ? 'border-emerald-400 bg-emerald-50/90 font-bold shadow-2xs'
                          : 'border-slate-200/80 bg-white hover:bg-slate-50'
                      }`}
                    >
                      {item.icon}
                      <div className="min-w-0">
                        <div className="text-xs font-bold text-slate-800 leading-tight truncate">{item.label}</div>
                        <div className="text-[10px] text-slate-400 font-medium truncate mt-0.5">{item.desc}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Intelligence */}
              <div>
                <div className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2 px-1">
                  Intelligence
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {intelligenceItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => handleSelectView(item.id)}
                      className={`p-2.5 rounded-2xl border text-left flex items-start gap-2.5 transition-all ${
                        currentView === item.id
                          ? 'border-emerald-400 bg-emerald-50/90 font-bold shadow-2xs'
                          : 'border-slate-200/80 bg-white hover:bg-slate-50'
                      }`}
                    >
                      {item.icon}
                      <div className="min-w-0">
                        <div className="text-xs font-bold text-slate-800 leading-tight truncate">{item.label}</div>
                        <div className="text-[10px] text-slate-400 font-medium truncate mt-0.5">{item.desc}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Administration */}
              {adminItems.length > 0 && (
                <div>
                  <div className="text-[10px] font-extrabold text-emerald-700 uppercase tracking-wider mb-2 px-1">
                    Administration & Controls
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    {adminItems.map((item) => (
                      <button
                        key={item.id}
                        onClick={() => handleSelectView(item.id)}
                        className={`p-2.5 rounded-2xl border text-left flex items-start gap-2.5 transition-all ${
                          currentView === item.id
                            ? 'border-emerald-400 bg-emerald-50/90 font-bold shadow-2xs'
                            : 'border-slate-200/80 bg-white hover:bg-slate-50'
                        }`}
                      >
                        {item.icon}
                        <div className="min-w-0">
                          <div className="text-xs font-bold text-slate-800 leading-tight truncate">{item.label}</div>
                          <div className="text-[10px] text-slate-400 font-medium truncate mt-0.5">{item.desc}</div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileBottomNav;
